import { Component, ChangeDetectorRef, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppService } from './app.service';
import { AppUris, selectionChangeForDetection } from './entities/app-config/model';
import { TopMenu, LevelOne, LevelTwo } from './entities/menu/model';
import { GlobalLabels, SelectionLists, CurrentSelection, Customer, JobSite, Equipment, MenuIdLevel } from './entities/global/model';
import { AppRoute } from './entities/app-config/model';
import { Subscription } from 'rxjs/Subscription';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { LoadingService } from './shared/services/loading.service';
import { MatDialog } from '@angular/material/dialog'; import { FindInspectedEquipmentPopupComponent } from './modules/inspection/create-new-inspection/find-inspected-equipment-popup/find-inspected-equipment-popup.component';
import { AboutPopupComponent } from './modules/about-popup/about-popup.component';
import { CreateNewWsreInspectionComponent } from './modules/inspection/create-new-wsre-inspection/create-new-wsre-inspection.component';
import { DealergroupBrandingComponent } from './modules/dealergroup-branding/dealergroup-branding.component';
import { EnterSafetyInspectionDialogComponent } from './modules/GET_NEW_UI/enter-safety-inspection-dialog/enter-safety-inspection-dialog.component';
import { ConfigAddTakeComponent } from './modules/GET_NEW_UI/config-add-take/config-add-take.component';
import { ConfigAddToolboxTalkComponent } from './modules/GET_NEW_UI/config-add-toolbox-talk/config-add-toolbox-talk.component';
import { ConfigAddMontlyDashbrdMessageComponent } from './modules/GET_NEW_UI/config-add-montly-dashbrd-message/config-add-montly-dashbrd-message.component';
import { EquipmentStatusPopupComponent } from './modules/equipment-status-popup/equipment-status-popup.component';
import { FleetReportConfigurationComponent } from './modules/dashboard/fleet-report-configuration/fleet-report-configuration.component';
import { CryptoService } from './services/crypto.service';
import { PerformInspectionComponent } from './modules/GET_NEW_UI/equipment-details/components/perform-inspection/perform-inspection.component';
import { PreferencesService } from './modules/preferences/preferences.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  @Input() implementforDashboard: number[] = [];
  TopMenu: TopMenu = new TopMenu();
  UriConfig: AppUris = new AppUris();
  selectedMenuLevel = new MenuIdLevel();
  // routeId: number = 0;
  routeItemId = 0;
  userName: string;
  globalLabels: GlobalLabels = new GlobalLabels();
  selectionLists: SelectionLists = new SelectionLists();
  currentSelection: CurrentSelection = new CurrentSelection();
  topMenuLoadingComplete = false;
  navbarMobileOpen = false;
  searchComponentIsVisible = false;
  customerId = 0;
  jobsiteId = 0;
  equipmentId = 0;
  familyId = 0;
  makeId = 0;
  modelId = 0;
  routeSubscription: Subscription;
  appUriSubscription: Subscription;
  loadingSubscription: Subscription;
  userLanguage = 'english';
  options = {
    position: ['top', 'right'],
    timeOut: 5000,
    lastOnBottom: true
  };
  GETUrl = '';
  _reloadTopMenu = false;
  _print_version: boolean;
  showLoadingBar: boolean;
  tabReplace: string = 'False';
  refreshItems: boolean = false;
  menuItemsVersion: number = 0;
  selectionChange: selectionChangeForDetection = new selectionChangeForDetection();
  currentUrl = '';
  
  constructor(
    private _appService: AppService,
    private titleService: Title,
    private _router: Router,
    private ref: ChangeDetectorRef,
    private _loading: LoadingService,
    private _dialog: MatDialog,
    private crypto: CryptoService,
    private _pref: PreferencesService,
    private router: Router
  ) {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: any) => {
      this.currentUrl = event.urlAfterRedirects;
    });
    this.currentSelection.customer = new Customer();
    this.currentSelection.jobSite = new JobSite();
    this.currentSelection.equipment = new Equipment();
  }
  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
  ngOnInit() {
    this.getReplaceExistingTabStatus();
    this.refreshMenuItems();
    this.loadingSubscription = this._loading.shouldDisplayLoadingBar().subscribe(showLoading =>
      setTimeout(() => this.showLoadingBar = showLoading)
    );
    //console.log("this._reloadTopMenu :", this._reloadTopMenu);
    this._router.events.subscribe(message => {
      // if (message instanceof NavigationStart) {
      //   if (this._reloadTopMenu == false) {
      //     //console.log("this._reloadTopMenu is.loadTopMenus :", this._reloadTopMenu);
      //     //this.refreshMenuItems();
      //     this.loadTopMenusNew(message.url);
      //     //this.loadTopMenuForUserBasedOnRoute(message.url);
      //     //this.loadTopMenuForUserBasedOnRouteBK(message.url);
      //     this._reloadTopMenu = true;
      //   }
      // }
      if (message instanceof NavigationEnd) {
        if (message.url.includes('fleet-print') || message.url.includes('components-print')) {
          setTimeout(() => {
            this._print_version = true;
          });
        } else {
          setTimeout(() => {
            this._print_version = false;
          });
        }
      }
    }, error => console.error(error), () => { });
    this.setTitle('Dashboard');
    this._loading.startLoading();
    //AES256
    this._appService.GetLoggedInUserName().subscribe(result => { this.userName = this.crypto.decrypt(result); this._loading.finishedLoading(); });
    //this._appService.GetLoggedInUserName().subscribe(result => { this.userName = result; this._loading.finishedLoading(); });
    this._loading.startLoading();
    this.appUriSubscription = this._appService.getAppUris().subscribe(result => setTimeout(() => { this.UriConfig = result; this.ref.detectChanges(); }, 10));
    this.routeSubscription = this._appService.getRouteMessage().subscribe(message => setTimeout(() => { this.updateByRoute(message); }, 10));
    //this.numberofNotification=this.Notifications.length;
  }
  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.appUriSubscription.unsubscribe();
    this.loadingSubscription.unsubscribe();
  }

  refreshMenuItems(){
    this._appService.getMenuItemsCurrentVersion().subscribe(result=>{
      this.menuItemsVersion = parseInt(result, 10);
      const localVersion = parseInt(localStorage.getItem("MenuItemsVersion") || '0', 10);
      if(this.menuItemsVersion != localVersion){
        this.refreshItems = true;
        localStorage.setItem("MenuItemsVersion", this.menuItemsVersion.toString());
      }
      this.loadTopMenusNew('');
    }, error=>{
      console.log("Error refreshing menu items:", error);
    });
  }

  getReplaceExistingTabStatus() {
    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      this.tabReplace = res;
    }, error=>{
      console.log("Error fetching replace existing tab status:", error);
    });
  }

  loadTopMenusNew(rpOrig: string) {
    if(this.refreshItems){
      this.loadTopMenuForUserBasedOnRouteSP();
    }
    else {
      this.TopMenu = JSON.parse(localStorage.getItem(location.host));
      if (this.TopMenu == null || this.TopMenu.Divisions == null || this.TopMenu.Divisions.length === 0) {
       this.loadTopMenuForUserBasedOnRouteSP();
      } else {
        this.TopMenu = JSON.parse(localStorage.getItem(location.host));
        this._appService.setTopMenu(this.TopMenu);
        this.topMenuLoadingComplete = true;
        this._loading.finishedLoading();
      }
    }
  }

  loadTopMenus(rpOrig: string) {
    //console.log("localStorage.getItem(TopMenu):", localStorage.getItem("TopMenu"))
    this.TopMenu = JSON.parse(localStorage.getItem(location.host));
    if (this.TopMenu == null || this.TopMenu.Divisions == null || this.TopMenu.Divisions.length === 0) {
      //console.log('TopMenu Divisions is null or empty');
      this.loadTopMenuForUserBasedOnRoute(rpOrig);
      this.loadTopMenuForUserBasedOnRouteBK(rpOrig);
    } else {
      //console.log('TopMenu Divisions count:', this.TopMenu.Divisions.length);
      this.TopMenu = JSON.parse(localStorage.getItem(location.host));
      this._appService.setTopMenu(this.TopMenu);
      this.topMenuLoadingComplete = true;
      this._loading.finishedLoading();
    }
    //if (localStorage.getItem("TopMenu") === null) {
    //  this.loadTopMenuForUserBasedOnRoute(rpOrig);
    //  this.loadTopMenuForUserBasedOnRouteBK(rpOrig);
    //}
    //else {
    //  this.TopMenu = JSON.parse(localStorage.getItem("TopMenu"));
    //  this._appService.setTopMenu(this.TopMenu);
    //  this.topMenuLoadingComplete = true;
    //  this._loading.finishedLoading();
    //}
  }

  loadTopMenuForUserBasedOnRoute(rpOrig: string) {
    const rp = rpOrig.split('/')[1];
    this._appService.GetTopMenuForUserAndRoute(rp).subscribe(result => {
      this.TopMenu = result;
      //console.log("top_menu__", this.TopMenu)
      this._appService.setTopMenu(this.TopMenu);
      this.topMenuLoadingComplete = true;
      this._loading.finishedLoading();
    }, error => { console.log(error); });
  }

  loadTopMenuForUserBasedOnRouteSP() {
    this._appService.GetTopMenuForUserAndRouteSP().subscribe(result => {
      this.TopMenu =  result;
      localStorage.setItem(location.host, JSON.stringify(result));
      this._appService.setTopMenu(this.TopMenu);
      this.topMenuLoadingComplete = true;
      this._loading.finishedLoading();
      this.ref.detectChanges();
    }, error => { console.error(error); });
  }

  loadTopMenuForUserBasedOnRouteBK(rpOrig: string) {
    const rp = rpOrig.split('/')[1];
    this._appService.GetTopMenuForUserAndRoute_BK(rp).subscribe(result => {
      this.TopMenu = result;
      localStorage.setItem(location.host, JSON.stringify(result));
      //console.log("top_menu__", this.TopMenu)
      this._appService.setTopMenu(this.TopMenu);
      this.topMenuLoadingComplete = true;
      //this._loading.finishedLoading();
    }, error => { console.log(error); });
  }

  toggleCssMenuExpandedL1(levelOne: LevelOne) {
    if (levelOne.LiCssClass.indexOf('-open') === -1)
      levelOne.LiCssClass += ' menu-item-open';
    else
      levelOne.LiCssClass = 'menu-item';
  }

  toggleCssMenuExpandedL2(levelTwo: LevelTwo) {
    if (levelTwo.LiCssClass.indexOf('-open') === -1)
      levelTwo.LiCssClass += ' sub-menu-item-open';
    else
      levelTwo.LiCssClass = 'sub-menu-item';
  }

  menuClicked(linkId: number, href: string, OpenInNewWindow: boolean, level: number) {
    this._appService.sendEnableSearch(false);
    //console.log('menu clicked', linkId, level, this._appService.IsInNewUI(linkId, level), href);
    //console.log('menu clicked href', href, OpenInNewWindow);
    let fullPath: string = this.UriConfig.oldUCUri;

    if (href != null) {
      let isHttpType = href.includes('http');
      if (isHttpType == true) {
        if (href.includes('SignOut') || href.includes('signout'))
          localStorage.removeItem(location.host);
        window.open(href, '_blank');
      } else {
        if (linkId === 1 && level === 3) { // new Inspection screen popup
          this.findInspectedEquipment();
        } 
        else if (linkId === 71 && level === 3) { // Update Eq Status
          this.UpdateEquipmentStatus();
        } 
        else if (linkId === 46 && level === 2) {
          this.openAbout();
        }
        else if (linkId === 33 && level === 2) {//GealerGroup Branding
          this.OpenDealerGroupBranding();
        }
        else if (linkId === 9 && level === 3) { // new wsre Inspection screen popup
          this.findWSREInspectedEquipment();
        }
        else if (linkId === 61 && level === 3) { //Enter New Observation Inspection
          this.openSafetyInspectionDialog();
        }
        else if (linkId === 54 && level === 3) { //Add ToolBox Talk
          this.openConfigAddToolboxTalkDialog();
        }
        else if (linkId === 57 && level === 3) { //Add Take 5s
          this.openConfigAddTakeDialog();
        }
        else if (linkId === 55 && level === 3) { //Add Dashboard Message
          this.openConfigAddMonthlyDashMessageDialog();
        }
        else if (linkId === 91 && level === 3) { // Fleet Reporting Popup
          this.openFleetReportingDialog();
        }
        else if (linkId == 47 && level == 2) {
          //console.log("location.host, window.location.hostname, href",location.host, window.location.hostname, href);
          localStorage.removeItem(location.host);
          window.open("https://" + window.location.hostname + href, '_blank');
          //window.location.href = window.location.hostname + href;
          //window.location.href = fullPath + 'Account/SignOut';
        }
        else if (linkId == 15 && level == 3){
          const dialogRef = this._dialog.open(PerformInspectionComponent, {
            width: '500px',
            maxHeight: '80vh',
            disableClose: true,
            data: {
              linkId: linkId,
              level: level
            }
          });
          dialogRef.afterClosed().subscribe(result => {
            console.log('Dialog closed', result);
          });
        }
        else if (this.tabReplace == "False") {
          window.open("https://" + window.location.hostname + href, '_blank');
        }
        else {
          //console.log("this is else", href)
          this._router.navigateByUrl(href);
        }
      }
    }
    else {
      if (linkId === 1 && level === 3) { // new Inspection screen popup
        this.findInspectedEquipment();
      } else if (linkId === 71 && level === 3) { // Update Eq Status
        this.UpdateEquipmentStatus();
      } else if (linkId === 46 && level === 2) {
        this.openAbout();
      }
      else if (linkId === 33 && level === 2) {//GealerGroup Branding
        this.OpenDealerGroupBranding();
      }
      else if (linkId === 9 && level === 3) { // new wsre Inspection screen popup
        this.findWSREInspectedEquipment();
      }
      else if (linkId === 61 && level === 3) { //Enter New Observation Inspection
        this.openSafetyInspectionDialog();
      }
      else if (linkId === 54 && level === 3) { //Add ToolBox Talk
        this.openConfigAddToolboxTalkDialog();
      }
      else if (linkId === 57 && level === 3) { //Add Take 5s
        this.openConfigAddTakeDialog();
      }
      else if (linkId === 55 && level === 3) { //Add Dashboard Message
        this.openConfigAddMonthlyDashMessageDialog();
      }
      else if (linkId === 91 && level === 3) { // Fleet Reporting Popup
        this.openFleetReportingDialog();
      }
      else if (linkId == 47 && level == 2) {
        //console.log("location.host, window.location.hostname, href",location.host, window.location.hostname, href);
        localStorage.removeItem(location.host);
        window.location.href = window.location.hostname + href;
        //window.location.href = fullPath + 'Account/SignOut';
      }
    }
    this.navbarMobileOpen = false;
  }


  private UpdateEquipmentStatus() {
    this._dialog.open(EquipmentStatusPopupComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        fromMenu: true,
      }
    });
  }
  private findInspectedEquipment() {
    this._dialog.open(FindInspectedEquipmentPopupComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        fromMenu: true,
      }
    });
  }
  private openAbout() {
    this._dialog.open(AboutPopupComponent, {
      panelClass: 'removeModalOverflow',
      data: {
      }
    });
  }
  private findWSREInspectedEquipment() {
    this._dialog.open(CreateNewWsreInspectionComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        fromMenu: true,
      }
    });
  }

  private OpenDealerGroupBranding() {
    this._dialog.open(DealergroupBrandingComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        fromMenu: true,
      }
    });
  }

  private openSafetyInspectionDialog() {
    this._dialog.open(EnterSafetyInspectionDialogComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        fromMenu: true,
      }
    });
  }

  private openConfigAddTakeDialog() {
    this._dialog.open(ConfigAddTakeComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        fromMenu: true,
      }
    });
  }

  private openConfigAddToolboxTalkDialog() {
    this._dialog.open(ConfigAddToolboxTalkComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        fromMenu: true,
      }
    });
  }

  private openConfigAddMonthlyDashMessageDialog() {
    this._dialog.open(ConfigAddMontlyDashbrdMessageComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        fromMenu: true,
      }
    });
  }

  private openFleetReportingDialog() {
    this._dialog.open(FleetReportConfigurationComponent, {
      panelClass: 'removeModalOverflow',
      maxHeight: '960px',
      data: {
        item: { id: 10 }
      }
    });

  }

  private redirectToTheOldAppJustForTemporaryUses(Id: number) {
    switch (Id) {
      case 2:
        window.location.href = this.UriConfig.oldUCUri + 'Track/Undercarriagehistory.aspx';
        break;
      case 3:
      case 4:
        window.location.href = this.UriConfig.oldUCUri + 'Track/TrackAnalyse.aspx';
        break;
      default:
    }
  }

  CheckStatus(pageId: number, level: number): boolean {
    return this._appService.showMeOrNot(pageId, level);
  }

  checkSerachBoxStatus() {
    return this._appService.showSearchBoxOrNot();
  }

  updateUserSelection(newSelection: CurrentSelection) {
    Object.assign(this.currentSelection, newSelection);
    this.customerId = newSelection.customer.Id;
    this.jobsiteId = newSelection.jobSite.Id;
    this.equipmentId = newSelection.equipment.Id;
    this.familyId = newSelection.family.Id;
    this.makeId = newSelection.make.Id;
    this.modelId = newSelection.model.Id;
  }

  updateByRoute(routeMessage: AppRoute) {
    this.setLinkMenuIdandLevel(routeMessage.routeId, routeMessage.routeLevel);
    this.setGlobalLabel(routeMessage.routeId, routeMessage.routeLevel);
    // this.routeId = routeMessage.routeId;
    this.routeItemId = routeMessage.itemId;
    this.setTitle(routeMessage.routeTitle);
  }

  setLinkMenuIdandLevel(linkId: number, level: number) {
    this.selectedMenuLevel.selectedMenuId = linkId;
    this.selectedMenuLevel.selectedLevel = level;
    this.ref.detectChanges();
  }

  setGlobalLabel(linkId: number, level: number) {
    if (linkId === 1 && level === 1) {
      this.globalLabels.currentPageTitle = 'Dashboard';
      this.globalLabels.currentPageHeader = 'Fleet Overview';
      this.globalLabels.backRoute = 'Dashboard';
    }
  }

  showPageComponentById(pageComponentId: number): boolean {
    if (pageComponentId === 1)
      return this._appService.showSearchBoxOrNot();
    if (pageComponentId === 2)
      return this._appService.showBreadCrumbOrNot();
  }

  getMarginClass(): string {
    if (this.router.url.includes('/equipment')) {
    //console.log("getMarginClass(margin-bottom-65):", true);
      return '';
    }
    return 'margin-bottom-65';
  }

}